<template>
    <div class="seller" ref="seller">
        <div class="seller-content">
            <div class="overview">
                <h1 class="title">{{seller.restaurantName}}</h1>
                <div class="desc">
                    <div class="text">
                        {{seller.address}} - {{seller.zipCode}} {{seller.zipName}}
                    </div>
                </div>
                <div class="business-hours">
                    <div class="text">
                        Mandag fra  <span class="hours">{{businessHours.MondayBegin}}   til  {{businessHours.MondayEnd}}</span>
                    </div>
                    <div class="text">
                        Tirsdag fra  <span class="hours">{{businessHours.TuesdayBegin}}   til  {{businessHours.TuesdayEnd}}</span>
                    </div>
                    <div class="text">
                        Onsdag fra  <span class="hours">{{businessHours.WednesdayBegin}}   til  {{businessHours.WednesdayEnd}}</span>
                    </div>
                    <div class="text">
                        Onsdag fra  <span class="hours">{{businessHours.ThursdayBegin}}   til  {{businessHours.ThursdayEnd}}</span>
                    </div>
                    <div class="text">
                        Fredag fra  <span class="hours">{{businessHours.FridayBegin}}  til  {{businessHours.FridayEnd}}</span>
                    </div>
                    <div class="text">
                        Lørdag fra  <span class="hours">{{businessHours.SaturdayBegin}}  til  {{businessHours.SaturdayEnd}}</span>
                    </div>
                    <div class="text">
                        Søndag fra  <span class="hours">{{businessHours.SundayBegin}}  til  {{businessHours.SundayEnd}}</span>
                    </div>
                </div>
                <div class="pic">
                    <h1 class="title">Seller information</h1>
                    <div class="pic-wrapper" ref="picWrapper">
                        <mu-carousel transition="fade" style="height:210px;">
                            <mu-carousel-item>
                                <img :src="getImgUrl(businessHours.BannerImage1)" height="200">
                            </mu-carousel-item>
                            <mu-carousel-item>
                                <img :src="getImgUrl(bannerImage.BannerImage2)" height="200">
                            </mu-carousel-item>
                            <mu-carousel-item>
                                <img :src="getImgUrl(bannerImage.BannerImage3)" height="200">
                            </mu-carousel-item>
                            <mu-carousel-item>
                                <img :src="getImgUrl(bannerImage.BannerImage4)" height="200">
                            </mu-carousel-item>
                        </mu-carousel>
                    </div>
                    <div class="description" v-html="seller.description">
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import BScroll from 'better-scroll'

export default {
  props: {
  },
  data () {
      return {
          seller: {},
        bannerImage: {},
        businessHours: {},
    }
  },
  computed: {

  },
        created() {
            this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
      this.bannerImage = JSON.parse(this.seller.bannerImage);
      this.businessHours = JSON.parse(this.seller.businessHours);
  },
        mounted() {
    this.scroll = new BScroll(this.$refs.seller, {
      click: true
    })
   
  },
  methods: {
    _initPics () {
      if (this.seller.pics) {
        let picWidth = 120
        let margin = 6
        this.$refs.pic.style.width = (picWidth + margin) * this.seller.pics.length - margin + 'px'
        this.$nextTick(() => {
          if (!this.picWrapperScroll) {
            this.picWrapperScroll = new BScroll(this.$refs.picWrapper, {
              scrollX: true,
              eventPassthrough: 'vertical'
            })
          } else {
            this.picWrapperScroll.refresh()
          }
        })
      }
    },

    getImgUrl(image) {
          if (image == undefined || image == 'undefined') {
              return '../static/img/default.png';
          }
        return this.imageBaseUrl + image;
      },
  },
  components: {
    
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
    .seller {
        top:110px;
        position:fixed;
        left: 0;
        right: 0;
        bottom: 0;
        max-width: 100%;
        margin: 0 auto;
        overflow: hidden;
        background-color: #eeeeee;      
    }
        .seller h1 {
            margin: 0;
        }
    .seller-content
    .overview {
        margin: 10px;
        position: relative;
        background-color: #fff;
        border-radius: 5px;
        overflow-y: auto;
    }
    .seller .title {
        font-size: 16px;
        line-height: 20px;
        color: #191919;
        font-weight: 600;
        padding-top: 10px;
    }
    .seller .desc {
        font-size: 0;
        margin-top: 5px;
    }

    .seller .text {
        vertical-align: top;
        display: inline-block;
        font-size: 14px;
        color: rgb(77,85,93);
        margin-right: 12px;
        line-height: 18px;
        width: 100%;
    }
    .seller .business-hours {
        margin-top: 15px;
        font-weight: 600;
        margin-bottom: 15px;
    }

    .seller .business-hours .hours {
            color: #da5b3a;
            font-weight: 600;
            float: right;
            margin-right: 20px;
        }
    .seller .description {
        padding-top: 5px;
        padding-bottom: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Seller.vue